





















































































































































































































































































































































































































































































































































































































































































import draggable from "vuedraggable";
import { sortItems, getAnswer, getFormulaIdOverview } from "@/services/checklist.service";
import { validateFormulaSyntax, findUnknownVars } from "@/services/formula_validator";
import {
  normalizeFieldDecimals,
  isFieldDecimalsPresent,
} from "@/services/field_decimals";
import { EventBus } from "@/event-bus";
import MachinesModal from "@/components/MachinesModal.vue";
import TranslatedItem from "@/components/TranslatedItem.vue";
import HelpIcon from "@/components/HelpIcon.vue";
import ClTableColumns from "./ClTableColumns.vue";
import CondFormatEditor from "./CondFormatEditor.vue";

export default {
  props: ["questionLoaded"],
  data() {
    return {
      filter1: null,
      answer_list: null,
      org_entry: {},
      org_machines: [],
      username: null,
      bc: null,
      showMachines: false,
      field_message_name_en: [],
      field_message_name_fr: [],
      sel_removemachines: [],
      sel_addmachines: [],
      sel_machinesingroup: [],
      calcExpanded: false,
      // Zustand des checklistenweiten Kastens (#398). Die Schluessel stehen
      // hier, damit Vue 2 sie von Anfang an beobachtet - ein erst nach dem
      // Abruf angelegtes Feld waere ohne `$set` nicht reaktiv (#365).
      clFormulaOverviewExpanded: false,
      // "idle" | "loading" | "ready" | "error"
      clFormulaOverviewState: "idle",
      clFormulaOverview: { formulaIds: [], rowKeyNames: [] },
      // Laufende Nummer des Abrufs: eine spaet eintreffende Antwort eines
      // frueheren Abrufs darf einen neueren nicht ueberschreiben.
      clFormulaOverviewSeq: 0,
      // Rohtext des Nachkommastellen-Feldes, solange der Anwender daran
      // tippt. `null` heißt "noch nicht angefasst" — dann zeigt das Feld
      // den Wert des Datensatzes. Ohne diesen Zwischenspeicher würde eine
      // ungültige Eingabe (`2,5`) sofort wieder aus der Maske verschwinden,
      // weil sie den Datensatz nicht erreicht; die Fehlermeldung stünde dann
      // unter einem leeren Feld.
      decimalsInput: null,
      question_fieldtype: [
        { text: this.$t('LABEL27'), value: "input" },
        { text: this.$t('LABEL28'), value: "textarea" },
        { text: this.$t('LABEL29'), value: "checkbox" },
        { text: this.$t('LABEL30'), value: "radio" },
        { text: this.$t('LABEL31'), value: "select" },
        { text: this.$t('LABEL32'), value: "calledContacts" },
        { text: this.$t('LABEL33'), value: "range" },
        { text: this.$t('LABEL34'), value: "serialNumber" },
        { text: this.$t('LABEL35'), value: "signature" },
        { text: this.$t('LABEL36'), value: "location" },
        { text: this.$t('LABEL37'), value: "radius" },
        { text: this.$t('LABEL38'), value: "barcode" },
        { text: this.$t('LABEL_TABLE'), value: "table" },
      ],
      question_fieldsubtype: [
        { text: "Text", value: "text" },
        { text: "Number", value: "number" },
        { text: "Date/Time", value: "datetime-local" },
        { text: "Date", value: "date" },
        { text: "Time", value: "time" },
        { text: "E-Mail", value: "email" },
      ],
    };
  },
  components: {
    draggable,
    MachinesModal,
    TranslatedItem,
    HelpIcon,
    ClTableColumns,
    CondFormatEditor,
  },
  computed: {
    appLang: function () {
      return this.$store.state.lang
    },
    mergeSeparatorOptions() {
      return [
        { text: this.$t("MERGE_SEP_SPACE"), value: " " },
        { text: this.$t("MERGE_SEP_COMMA"), value: ", " },
        { text: this.$t("MERGE_SEP_SLASH"), value: " / " },
      ];
    },
    onlyPV: function () {
      return this.$store.getters.userRole.db_region //this.userRole.db_region == 'eso'
    },
    pasteEntryVal() {
      return this.$store.state.pasteEntryOptionVal;
    },
    copy_entry() {
      return (
        this.$store.state.copy_entry &&
        this.$store.state.copy_entry.type == "question"
      );
    },
    show_subtype() {
      return this.entry && this.entry.fieldtype == "input";
    },
    entry() {
      if (this.$store.state.cl_question) {
        if (!this.$store.state.cl_question.format) {
          this.$store.state.cl_question.format = "%K: %V %U\n";
          this.$store.state.cl_question.format_en = "%K: %V %U\n";
        }

        if (!this.$store.state.cl_question.machinegroup_list) {
          this.$store.state.cl_question.machinegroup_list = [];
        }

        if (this.$store.state.cl_question.machinegroup) {
          if (!this.$store.state.cl_question.machinegroup_created) {
            this.$store.state.cl_question.machinegroup_created = true;
            this.$store.state.cl_question.machinegroup_list = [
              this.$store.state.cl_question.machinegroup,
            ];
          }
        }

        this.$store.state.cl_component.machinegroup_created = true;

        return this.$store.state.cl_question;
      }
      return {};
    },
    answers: {
      get() {
        return this.$store.state.cl_answer_list;
      },
      set(value) {
        this.$store.state.cl_answer_list = value;
      },
    },
    machinegroups() {
      return this.$store.state.cl_machine_groups;
    },
    projects() {
      return this.$store.state.projects;
    },
    machines() {
      if (this.filter1 && this.filter1.length > 0) {
        return this.$store.state.machines.filter((machine) => {
          return (
            machine.text.toLowerCase().indexOf(this.filter1.toLowerCase()) !==
            -1
          );
        });
      }
      return this.$store.state.machines;
    },
    saving() {
      return (
        this.$store.state.saving && this.$store.state.saving_type == "question"
      );
    },
    hasChanges() {
      if (!this.org_entry || !this.entry || !this.org_entry._id) return false;
      let a = { ...this.org_entry }; let b = { ...this.entry };
      delete a.created_at; delete b.created_at;
      delete a.user_uid; delete b.user_uid;
      return JSON.stringify(a) !== JSON.stringify(b);
    },
    show_answers() {
      return (
        this.entry.fieldtype == "radio" ||
        this.entry.fieldtype == "select" ||
        this.entry.fieldtype == "checkbox"
      );
    },
    calcFormulaIdError() {
      const id = (this.entry.calcFormulaId || "").trim();
      if (id === "") return [];
      if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(id)) return [this.$t("CALC_FORMULA_ID_INVALID")];
      // Selbsterkennung ueber beide Schluessel, wie in `calcRowKeyConflict`
      // und `taskFormulaIds`: `cl_question_list` kommt in zwei Formen aus dem
      // Backend, und die duenne Form traegt kein `_id`. Ein Vergleich allein
      // ueber `_id` laesst die eigene Zeile dann stehen, und der Pruefpunkt
      // meldet sich selbst als Dublette.
      const entry = this.entry || {};
      const siblings = (this.$store.state.cl_question_list || []).filter((f) => {
        if (!f) return false;
        if (entry._id !== undefined && f._id === entry._id) return false;
        if (entry.uid !== undefined && f.value === entry.uid) return false;
        return true;
      });
      const duplicates = siblings.filter((f) => f.calcFormulaId === id);
      if (duplicates.length === 0) return [];
      // Namen der kollidierenden Prüfpunkte; `text` ist der Prüfpunktname aus
      // der Aufgaben-Liste und kann leer sein, wenn der Prüfpunkt keinen Namen
      // trägt.
      const names = duplicates
        .map((f) => (f.text || "").trim())
        .filter((t) => t !== "");
      if (names.length === 0) return [this.$t("CALC_FORMULA_ID_DUPLICATE")];
      return [this.$t("CALC_FORMULA_ID_DUPLICATE_AT").replace("{name}", names.join(", "))];
    },
    // Hinweis, keine Sperre: traegt ein anderer Pruefpunkt derselben Aufgabe
    // schon die Zeilenschluessel-Spalte, wird sein Name genannt. Im Bericht
    // gewinnt die erste Schluesselspalte in Feldreihenfolge; gesperrt wird hier
    // nichts, weil der Designer die Reihenfolge nicht entscheidet.
    //
    // Quelle ist `cl_question_list` - dieselbe aufgabenlokale Liste wie bei
    // `calcFormulaIdError` und `taskFormulaIds` (Backend-Filter
    // {cl_uid, task_uid, removed:false}).
    //
    // `calcRowKey` traegt die Liste erst mit dem erweiterten Backend-Stand.
    // Laeuft noch ein aelterer, fehlt die Eigenschaft, `=== true` trifft nicht
    // und es erscheint kein Hinweis - dieselbe Zurueckhaltung wie bei
    // `taskFormulaIds`, wo "Eigenschaft fehlt" nicht als "nichts vergeben"
    // ausgegeben wird. Ein Hinweis waere hier eine Behauptung ueber Daten, die
    // diese Liste gar nicht enthaelt.
    //
    // Rueckgabe: Namen der anderen Schluesselspalten als Text, sonst "".
    calcRowKeyConflict() {
      const entry = this.entry || {};
      if (entry.calcRowKey !== true) return "";
      const list = Array.isArray(this.$store.state.cl_question_list)
        ? this.$store.state.cl_question_list
        : [];
      const trim = (v) => (typeof v === "string" ? v.trim() : "");
      // Selbsterkennung ueber beide Schluessel: `_id` wie in
      // `calcFormulaIdError`, `value` (= uid) wie in `taskFormulaIds` - die
      // Liste kommt in zwei Formen aus dem Backend.
      const others = list.filter((f) => {
        if (!f || f.calcRowKey !== true) return false;
        if (entry._id !== undefined && f._id === entry._id) return false;
        if (entry.uid !== undefined && f.value === entry.uid) return false;
        return true;
      });
      if (others.length === 0) return "";
      return others
        .map((f) => trim(f.text) || this.$t("CALC_FORMULA_ID_LIST_NO_NAME"))
        .join(", ");
    },
    // Uebersicht der Formel-IDs dieser einen Aufgabe (der Backend-Filter der
    // Liste ist {cl_uid, task_uid, removed:false}). Quelle ist ausschliesslich
    // `cl_question_list`, damit Anzeige und Dublettenpruefung denselben
    // Datensatz sehen. Reine Ableitung: schreibt nichts, laedt nichts.
    //
    // Die Liste landet in zwei Formen im Store. Der Einfuegen-/Duplizieren-Pfad
    // lieferte sie ohne `calcFormulaId`; erst die erweiterte Fassung des
    // Backends traegt das Feld auch dort. Weil Deploys je Repo getrennt laufen,
    // muss diese Anzeige beide Formen aushalten - und "Feld fehlt" von "Feld ist
    // leer" unterscheiden, sonst behauptet sie "keine ID vergeben", waehrend
    // gerade IDs vervielfaeltigt wurden. Deshalb `hasOwnProperty` auf der
    // Eigenschaft, nicht eine Pruefung des Wertes.
    taskFormulaIds() {
      const list = Array.isArray(this.$store.state.cl_question_list)
        ? this.$store.state.cl_question_list
        : [];
      const entry = this.entry || {};
      const currentUid = entry.uid;
      const hasCurrentUid =
        currentUid !== undefined && currentUid !== null && currentUid !== "";
      const trim = (v) => (typeof v === "string" ? v.trim() : "");
      const liveId = trim(entry.calcFormulaId);

      let fieldPresent = false;
      let currentSeen = false;
      const rows = [];

      list.forEach((f, idx) => {
        if (!f) return;
        if (Object.prototype.hasOwnProperty.call(f, "calcFormulaId")) {
          fieldPresent = true;
        }
        // Treffer ueber `value`: das ist in beiden Listenformen `entry.uid`.
        const isCurrent = hasCurrentUid && f.value === currentUid;
        if (isCurrent) currentSeen = true;
        // Der gerade bearbeitete Pruefpunkt zeigt seinen Live-Wert - sonst
        // widerspraeche die Zeile beim Tippen der Meldung direkt darueber.
        const id = isCurrent ? liveId : trim(f.calcFormulaId);
        if (id === "") return;
        rows.push({
          key: "q" + idx,
          id: id,
          name: trim(f.text),
          current: isCurrent,
          duplicate: false,
        });
      });

      // Ein neu angelegter Pruefpunkt steht noch nicht in der Liste; seine ID
      // ist trotzdem vergeben. Der Name wird nach derselben Regel gewaehlt wie
      // das `text` der Liste (Backend: `transName`) - Sprachfassung, sonst die
      // deutsche.
      if (!currentSeen && liveId !== "") {
        const lang = this.$store.state.lang;
        const localized = lang ? trim(entry["name_" + lang]) : "";
        rows.push({
          key: "current",
          id: liveId,
          name: localized !== "" ? localized : trim(entry.name),
          current: true,
          duplicate: false,
        });
      }

      // Ohne Prototyp-Kette: eine gespeicherte ID kann jeden String tragen.
      const counts = Object.create(null);
      rows.forEach((r) => {
        counts[r.id] = (counts[r.id] || 0) + 1;
      });
      rows.forEach((r) => {
        r.duplicate = counts[r.id] > 1;
      });

      let state = "list";
      if (list.length > 0 && !fieldPresent) {
        state = "stale";
      } else if (rows.length === 0) {
        state = "empty";
      }

      return { state: state, rows: state === "list" ? rows : [] };
    },
    // Welche checklistenweiten Namen `<Schluessel>_<FormelID>` diese Aufgabe
    // bereitstellt (#386). Reine Ableitung aus `cl_question_list` und
    // `cl_answer_list`: kein Request, kein Schreiben auf `entry`.
    //
    // Der Client sieht nur den geoeffneten Pruefpunkt vollstaendig. Von den
    // Geschwistern traegt `cl_question_list` `text`, `value`, `calcFormulaId`
    // und `calcRowKey` - NICHT `fieldtype`, nicht `calcValueFormula` und nicht
    // die Antwortmoeglichkeiten. Konkrete Namen entstehen deshalb nur, wenn der
    // geoeffnete Pruefpunkt selbst die Schluesselspalte und ein Auswahlfeld
    // ist; sonst bleibt das Praefix offen.
    //
    // Rueckgabe: { state, column, rows, skipped }. `state === "none"` blendet
    // den Kasten aus.
    calcRowKeyNames() {
      const entry = this.entry || {};
      const list = Array.isArray(this.$store.state.cl_question_list)
        ? this.$store.state.cl_question_list
        : [];
      const trim = (v) => (typeof v === "string" ? v.trim() : "");
      const noName = () => this.$t("CALC_FORMULA_ID_LIST_NO_NAME");
      const result = (state, extra = null) =>
        Object.assign({ state: state, column: "", rows: [], skipped: false }, extra || {});

      // Selbsterkennung wie in `calcFormulaIdError` und `calcRowKeyConflict`:
      // die Liste kommt in zwei Formen, die duenne ohne `_id`.
      const isSelf = (f) => {
        if (entry._id !== undefined && f._id === entry._id) return true;
        if (entry.uid !== undefined && f.value === entry.uid) return true;
        return false;
      };

      const ownIsKey = entry.calcRowKey === true;
      const otherKeys = list.filter((f) => f && f.calcRowKey === true && !isSelf(f));

      // Fall D: keine Schluesselspalte in dieser Aufgabe - kein Kasten, kein
      // Leer-Hinweis. Traegt die Liste `calcRowKey` gar nicht (aelterer
      // Backend-Stand), trifft `=== true` nicht und es bleibt bei Fall D:
      // dieselbe Zurueckhaltung wie bei `calcRowKeyConflict`.
      if (!ownIsKey && otherKeys.length === 0) return result("none");

      // Fall C: die Schluesselspalte ist ein fremder Pruefpunkt. Sein
      // `fieldtype` und seine Antwortmoeglichkeiten stehen dem Client nicht zur
      // Verfuegung - Auswahlfeld und Freitext sind dort nicht unterscheidbar,
      // also wird nicht geraten.
      if (!ownIsKey) {
        return result("foreign", {
          column: otherKeys.map((f) => trim(f.text) || noName()).join(", "),
        });
      }

      // Waechter (D3b): fuehrt die Aufgabe mehrere Schluesselspalten, gewinnt im
      // Bericht die erste in Feldreihenfolge
      // (`inspect-backend/inspect/services/row_key_globals.js#_collectTask`,
      // die uebrigen nur mit `console.warn` verworfen). Diese Reihenfolge kennt
      // der Client nicht; konkrete Namen koennten die der unterlegenen Spalte
      // sein. Steht vor dem Ankreuzfeld-Fall: gewinnt eine andere Spalte,
      // stellt die Aufgabe sehr wohl Namen bereit.
      if (otherKeys.length > 0) return result("conflict");

      // Fall E: Ankreuzfeld. `row_key_globals.js#_rowKey` liefert fuer
      // `type === "checkbox"` `null`, und `_collectTask` ueberspringt jede
      // Zeile mit `null` - eine solche Schluesselspalte veroeffentlicht keine
      // Zeile.
      if (entry.fieldtype === "checkbox") return result("checkbox");

      // Fall B: Freitext - der Schluessel ist der eingetragene Zeilenwert, den
      // der Designer nicht kennt.
      if (entry.fieldtype !== "select" && entry.fieldtype !== "radio") {
        return result("open");
      }

      // Waechter (D3a): der Laufzeit-Schluessel eines Auswahlfeldes ist der
      // Basisname der Antwortmoeglichkeit - `row_key_globals.js#_optionName`
      // liest `name.de` zuerst, und `checklist_export.js#convertOptionsToObj`
      // setzt `name.de` unbedingt auf `opt.name`. `cl_answer_list.text` ist
      // dagegen in die Sitzungssprache aufgeloest (`transName`) und traegt kein
      // `name_de`. In einer deutschen Sitzung faellt beides zusammen, in einer
      // anderen nach der ersten Antwort-Bearbeitung nicht mehr. Die Abweichung
      // gehoert ins Backend und hat dort keine Karte; hier wird sie nicht
      // geraten, sondern das Praefix offengelassen.
      if (this.appLang !== "de") return result("lang");

      // Die Liste kann aus dem Einfuegen-/Duplizieren-Pfad ohne
      // `calcFormulaId` kommen. Dann ist "keine weitere Spalte traegt eine
      // Formel-ID" nicht messbar - dieselbe Unterscheidung, die
      // `taskFormulaIds` schon trifft.
      if (this.taskFormulaIds.state === "stale") return result("stale");

      // Die Schluesselspalte selbst wird nicht veroeffentlicht
      // (`_collectTask`: `if (!ff || ff === keyFf) continue;`), gerechnete
      // Spalten ebenfalls nicht - letztere kennt der Client nur fuer den
      // geoeffneten Pruefpunkt, deshalb bleibt die Anzeige beschreibend.
      const ids = [];
      list.forEach((f) => {
        if (!f || isSelf(f)) return;
        const id = trim(f.calcFormulaId);
        if (id === "" || ids.indexOf(id) !== -1) return;
        ids.push(id);
      });

      // Schluessel ausserhalb der Vertragsform werden zur Laufzeit
      // uebersprungen (`row_key_globals.js`, `KEY_PATTERN`). Sie duerfen hier
      // nicht als Name stehen - und ihr Wegfall wird benannt statt verschwiegen.
      const answers = Array.isArray(this.answers) ? this.answers : [];
      const keys = [];
      let skipped = false;
      answers.forEach((a) => {
        const key = trim(a && a.text);
        if (key === "") return;
        if (!/^[A-Za-z_][A-Za-z0-9_]*$/.test(key)) {
          skipped = true;
          return;
        }
        if (keys.indexOf(key) === -1) keys.push(key);
      });

      const rows = [];
      keys.forEach((key) => {
        ids.forEach((id) => {
          rows.push({ key: key + "|" + id, name: key + "_" + id });
        });
      });
      if (rows.length === 0) return result("nonames", { skipped: skipped });
      return result("names", { rows: rows, skipped: skipped });
    },
    // Der erklaerende Satz zum Zustand des Kastens. Jeder Fall traegt einen
    // eigenen Text: die Aussagen unterscheiden sich ("stellt nichts bereit" ist
    // etwas anderes als "Praefix offen").
    calcRowKeyNamesNotice() {
      const info = this.calcRowKeyNames;
      if (info.state === "foreign") {
        return this.$t("CALC_ROW_KEY_NAMES_FOREIGN").replace("{name}", info.column);
      }
      if (info.state === "conflict") return this.$t("CALC_ROW_KEY_NAMES_CONFLICT");
      if (info.state === "checkbox") return this.$t("CALC_ROW_KEY_NAMES_CHECKBOX");
      if (info.state === "open") return this.$t("CALC_ROW_KEY_NAMES_OPEN");
      if (info.state === "lang") return this.$t("CALC_ROW_KEY_NAMES_LANG");
      if (info.state === "stale") return this.$t("CALC_FORMULA_ID_LIST_STALE");
      if (info.state === "nonames") return this.$t("CALC_ROW_KEY_NAMES_NONE_YET");
      return "";
    },
    // Ausloeser des checklistenweiten Abrufs (#398): Checkliste + geoeffneter
    // Pruefpunkt. NICHT `entry._id` wie der bestehende Watcher - `_id` traegt
    // nur die volle Form des Datensatzes, und der Abruf soll auch dann
    // anlaufen, wenn es fehlt.
    //
    // Der leere String heisst "jetzt nicht abrufen". Er entsteht, solange noch
    // ein Laden fuer einen anderen Pruefpunkt laeuft: `cl_question_uid` traegt
    // dann bereits den neuen, `entry` noch den vorigen Datensatz. Ohne diese
    // Klammer liefe je Auswahl ein Abruf zu viel. Traegt der Store gar kein
    // `cl_question_uid`, wird nicht geklammert.
    clFormulaOverviewKey() {
      const clUid = this.$store.state.cl_uid;
      if (!clUid) return "";
      const entry = this.entry || {};
      const uid = entry.uid;
      const selected = this.$store.state.cl_question_uid;
      if (selected && uid && selected !== uid) return "";
      return clUid + "|" + (uid || "");
    },
    // Die Formel-IDs der ganzen Checkliste als Zeilen. Reine Ableitung aus der
    // Antwort des Endpunkts: der Client filtert nichts nach (Deaktiviertes
    // laesst das Backend bereits weg) und rechnet keine Namen nach.
    clFormulaIdRows() {
      const entry = this.entry || {};
      const currentUid = entry.uid;
      const hasCurrentUid =
        currentUid !== undefined && currentUid !== null && currentUid !== "";
      const trim = (v) => (typeof v === "string" ? v.trim() : "");
      const list = Array.isArray(this.clFormulaOverview.formulaIds)
        ? this.clFormulaOverview.formulaIds
        : [];
      return list.map((f, idx) => ({
        key: "cf" + idx,
        id: trim(f && f.calcFormulaId),
        name: trim(f && f.questionName),
        path: this._formulaPathText(f && f.path),
        // Der eigene Eintrag: die Antwort traegt kein `_id`, die Paarung laeuft
        // also ueber `questionUid` gegen `entry.uid` - derselbe Schluessel, den
        // `taskFormulaIds` als `value` vergleicht.
        current: hasCurrentUid && !!f && f.questionUid === currentUid,
      }));
    },
    // Die checklistenweiten Namen `<Schluessel>_<FormelID>` aus ALLEN Aufgaben.
    // Ohne die Sprachsperre des aufgabenlokalen Kastens: dort ist die Quelle
    // `cl_answer_list.text` (in die Sitzungssprache aufgeloest), hier bildet
    // das Backend den Namen aus dem Basisnamen der Option - derselbe Wert, aus
    // dem der Bericht den Schluessel bildet.
    clRowKeyNameRows() {
      const entry = this.entry || {};
      const currentUid = entry.uid;
      const hasCurrentUid =
        currentUid !== undefined && currentUid !== null && currentUid !== "";
      const trim = (v) => (typeof v === "string" ? v.trim() : "");
      const list = Array.isArray(this.clFormulaOverview.rowKeyNames)
        ? this.clFormulaOverview.rowKeyNames
        : [];
      const rows = [];
      list.forEach((r, idx) => {
        const name = trim(r && r.name);
        if (name === "") return;
        rows.push({
          key: "rk" + idx,
          name: name,
          path: this._formulaPathText(r && r.path),
          current: hasCurrentUid && !!r && r.questionUid === currentUid,
        });
      });
      return rows;
    },
    calcValueFormulaError() {
      return this._validateFormulaField(this.entry.calcValueFormula);
    },
    calcMinFormulaError() {
      return this._validateFormulaField(this.entry.calcMinFormula);
    },
    calcWarnFormulaError() {
      return this._validateFormulaField(this.entry.calcWarnFormula);
    },
    calcMaxFormulaError() {
      return this._validateFormulaField(this.entry.calcMaxFormula);
    },
    // Sichtbar, sobald es einen gerechneten Wert gibt — die Einstellung gilt
    // nur für den. Zusätzlich sichtbar, solange der Datensatz eine Angabe
    // trägt (auch `0`) oder der Anwender gerade tippt: sonst bliebe ein
    // bereits gesetzter Wert nach dem Löschen der Formel unsichtbar in der
    // Datenbank stehen, und das Feld verschwände beim Leeren unter dem
    // Cursor.
    showFieldDecimals() {
      const e = this.entry || {};
      const formula =
        typeof e.calcValueFormula === "string" ? e.calcValueFormula.trim() : "";
      if (formula.length > 0) return true;
      if (isFieldDecimalsPresent(e.field_decimals)) return true;
      return this.decimalsInput !== null;
    },
    fieldDecimals: {
      get() {
        if (this.decimalsInput !== null) return this.decimalsInput;
        const v = (this.entry || {}).field_decimals;
        return isFieldDecimalsPresent(v) ? String(v) : "";
      },
      set(value) {
        const raw = value === undefined || value === null ? "" : String(value);
        this.decimalsInput = raw;

        if (raw.trim().length === 0) {
          // Nur ein leeres Feld löscht. "Nicht gesetzt" ist die Abwesenheit
          // des Attributs — nicht `0`, nicht `null`, nicht `""`.
          if (
            Object.prototype.hasOwnProperty.call(this.entry, "field_decimals")
          ) {
            this.$delete(this.entry, "field_decimals");
          }
          return;
        }

        const n = normalizeFieldDecimals(raw);
        if (n === undefined) {
          // Ungültig und nicht leer: den Datensatz gar nicht anfassen — das
          // ist überhaupt kein Schreibvorgang. Der Rohtext bleibt mit seiner
          // Fehlermeldung in der Maske stehen, der gespeicherte Stand bleibt
          // unverändert; ein ungültiger Wert wird von hier aus nie gesetzt.
          //
          // Ein Löschen wäre hier in zwei erreichbaren Zuständen unsichtbar:
          // die Fehlermeldung liegt im zugeklappten Rechen-Abschnitt unter
          // `v-show` (`display: none`), und `updateInformElement` ruft
          // `save()`, sobald ein Element anderen Typs speichert (etwa die
          // Nachbaraufgabe) — ohne dass am Prüfpunkt je ein Speichern-Knopf
          // gedrückt wurde. Beide Fälle stehen als Test in
          // `tests/unit/ClQuestionDecimals.spec.ts`.
          return;
        }

        if (this.entry.field_decimals !== n) {
          // `$set`, weil der Schlüssel bei einem Bestands-Prüfpunkt fehlt
          // und eine schlichte Zuweisung dort nicht reaktiv wäre.
          this.$set(this.entry, "field_decimals", n);
        }
      },
    },
    fieldDecimalsError() {
      const raw = this.fieldDecimals;
      // Leer ist gültig und bedeutet "nicht gesetzt" — keine Meldung.
      if (raw.trim().length === 0) return [];
      if (normalizeFieldDecimals(raw) === undefined) {
        return [this.$t("CALC_DECIMALS_INVALID")];
      }
      return [];
    },
  },
  mounted() {
    EventBus.$on("question_changed", this.questionChangedHandler);
    EventBus.$on("updateInformElement", this.updateInformElement);

    if (!this.bc) {
      this.bc = new BroadcastChannel("checklist");
      this.bc.onmessage = (eventMessage) => {
        if (eventMessage.data && eventMessage.data.type == "COPY_OPTION") {
          this.$store.state.pasteEntryOptionVal = eventMessage.data.pasteItem;
        }
      };
    }

    this.updateUsername();
  },
  destroyed() {
    EventBus.$off("question_changed", this.questionChangedHandler);
    EventBus.$off("updateInformElement", this.updateInformElement);
  },
  /*
  watch: {
    answers: function (val, oldVal) {
      console.log("watch answers")
      this.answer_list = val
    }
  },
  */
  watch: {
    "entry._id": {
      immediate: true,
      handler() {
        const e = this.entry || {};
        const hasCalc =
          (e.calcFormulaId && e.calcFormulaId.length > 0) ||
          (e.calcValueFormula && e.calcValueFormula.length > 0) ||
          (e.calcMinFormula && e.calcMinFormula.length > 0) ||
          (e.calcMaxFormula && e.calcMaxFormula.length > 0) ||
          (e.calcWarnFormula && e.calcWarnFormula.length > 0) ||
          (e.displayBelowThreshold && String(e.displayBelowThreshold).length > 0) ||
          (e.displayAboveThreshold && String(e.displayAboveThreshold).length > 0) ||
          e.renderAsStatusSymbol === true ||
          e.showStatusSymbol === true ||
          e.calcRowKey === true ||
          // Nicht auf Truthiness prüfen: `0` ist eine gesetzte Angabe.
          isFieldDecimalsPresent(e.field_decimals) ||
          (Array.isArray(e.calcMapping) && e.calcMapping.length > 0);
        this.calcExpanded = !!hasCalc;
        // Der Rohtext gehört zum vorherigen Prüfpunkt.
        this.decimalsInput = null;
      },
    },
    // Wechselt die Checkliste oder der geoeffnete Pruefpunkt, gehoert der
    // Inhalt des checklistenweiten Kastens zum vorherigen Stand. Er wird
    // verworfen; neu geladen wird nur, solange der Kasten offen ist - siehe
    // `loadClFormulaOverview`.
    //
    // OHNE `immediate` — anders als der Watcher darueber. Der Anfangszustand
    // steht schon in `data()` (zugeklappt, "idle", leere Listen), es gibt also
    // nichts zu setzen. Gemessen: ein `immediate`-Lauf faellt in `initState`,
    // wo `Dep.target` noch der Render-Watcher des Elternteils ist; das Lesen
    // des Zaehlers haengt ihn an das Feld, das anschliessende Schreiben stoesst
    // mitten in die laufende Montage und bricht sie ab
    // ("Cannot read property '$scopedSlots' of undefined").
    clFormulaOverviewKey: {
      handler(key) {
        this.clFormulaOverviewSeq++;
        this.clFormulaOverview = { formulaIds: [], rowKeyNames: [] };
        this.clFormulaOverviewState = "idle";
        if (key !== "" && this.clFormulaOverviewExpanded) {
          this.loadClFormulaOverview();
        }
      },
    },
  },
  methods: {
    // Der sichtbare Text einer Zeile der Formel-ID-Uebersichten: der Name, bei
    // leerem Namen der Bestandsplatzhalter, dazu die Markierung des eigenen
    // Pruefpunkts. Zellentext und `title` derselben Zelle rufen diese eine
    // Stelle auf - zwei Stellen, die denselben Text bilden, laufen
    // auseinander.
    //
    // Die untere Liste des dritten Kastens (`clRowKeyNameRows`) laesst leere
    // Namen gar nicht erst durch; der Platzhalter-Zweig aendert dort nichts an
    // der Ausgabe.
    formulaRowLabel(row) {
      const name = row && typeof row.name === "string" ? row.name : "";
      const text = name === "" ? this.$t("CALC_FORMULA_ID_LIST_NO_NAME") : name;
      if (!row || !row.current) return text;
      return text + " " + this.$t("CALC_FORMULA_ID_LIST_CURRENT");
    },
    // Der Pfad eines Eintrags als Text. Der Vertrag sagt `string[]`
    // (Komponentenkette von oben nach unten, zuletzt die Aufgabe); ein Glied
    // ohne Namen wird durch den Bestandsplatzhalter ersetzt, statt die Kette zu
    // verkuerzen - sonst verschoebe sich die Tiefe stillschweigend.
    _formulaPathText(path) {
      if (!Array.isArray(path) || path.length === 0) return "";
      const noName = this.$t("CALC_FORMULA_ID_LIST_NO_NAME");
      return path
        .map((p) => (typeof p === "string" ? p.trim() : ""))
        .map((p) => (p === "" ? noName : p))
        .join(" › ");
    },
    // Abruf der checklistenweiten Uebersicht (#398).
    //
    // Kein Zwischenspeicher: jede Anzeige zeigt, was der Abruf zu ihrem
    // Zeitpunkt geliefert hat. Der aufgabenlokale Kasten darueber erkennt
    // seinen eigenen Alterungsfall ueber `cl_question_list`
    // (`CALC_FORMULA_ID_LIST_STALE`); dieser Zustand wird hier NICHT
    // uebernommen, weil er eine Aussage ueber den Store ist und nicht ueber
    // diese Antwort. Statt einen fremden Alterungszustand zu spiegeln, wird
    // neu geladen, sobald der Kasten aufgeklappt wird oder sich der geoeffnete
    // Pruefpunkt bei offenem Kasten aendert.
    loadClFormulaOverview() {
      const key = this.clFormulaOverviewKey;
      const seq = ++this.clFormulaOverviewSeq;
      // Kein Abruf, solange der Ausloeser leer ist (keine Checkliste, oder das
      // Laden eines anderen Pruefpunkts laeuft noch). Der Zustand bleibt
      // "idle"; sobald der Schluessel steht, holt der Watcher es nach.
      if (key === "") {
        this.clFormulaOverview = { formulaIds: [], rowKeyNames: [] };
        this.clFormulaOverviewState = "idle";
        return;
      }
      const clUid = this.$store.state.cl_uid;
      this.clFormulaOverview = { formulaIds: [], rowKeyNames: [] };
      this.clFormulaOverviewState = "loading";
      getFormulaIdOverview(clUid)
        .then((resp) => {
          if (seq !== this.clFormulaOverviewSeq) return;
          const data = (resp && resp.data) || {};
          // Fehlt eine der beiden Listen, ist die Antwort nicht die
          // vereinbarte. Dann lieber der Hinweis als eine halbe Liste, die wie
          // Vollstaendigkeit aussieht.
          if (!Array.isArray(data.formulaIds) || !Array.isArray(data.rowKeyNames)) {
            this.clFormulaOverview = { formulaIds: [], rowKeyNames: [] };
            this.clFormulaOverviewState = "error";
            return;
          }
          this.clFormulaOverview = {
            formulaIds: data.formulaIds,
            rowKeyNames: data.rowKeyNames,
          };
          this.clFormulaOverviewState = "ready";
        })
        .catch((err) => {
          // Kein `handleApiError` und kein Snackbar: der Kasten ist reine
          // Anzeige, ein Fehlschlag hier soll die Bearbeitung des Pruefpunkts
          // nicht unterbrechen. Ohne Spur bliebe er aber unsichtbar, deshalb
          // die Konsolenzeile.
          console.warn("[ClQuestion] formula-ids konnten nicht geladen werden", err);
          if (seq !== this.clFormulaOverviewSeq) return;
          this.clFormulaOverview = { formulaIds: [], rowKeyNames: [] };
          this.clFormulaOverviewState = "error";
        });
    },
    toggleClFormulaOverview() {
      this.clFormulaOverviewExpanded = !this.clFormulaOverviewExpanded;
      if (this.clFormulaOverviewExpanded) this.loadClFormulaOverview();
    },
    setMergeSeparator(value) {
      this.$set(this.entry, "mergeSeparator", value);
    },
    // `$set` statt einer Zuweisung per `v-model`: an einem Datensatz, der vor
    // der Schema-Erweiterung gespeichert wurde, fehlt `calcRowKey` als
    // Eigenschaft. Eine gewoehnliche Zuweisung erreicht das Objekt zwar, bleibt
    // aber ohne Abhaengigkeit (Vue 2) - die Bindung der Checkbox und der
    // Konflikt-Hinweis daneben wuerden nicht neu berechnet. Gleiches Muster wie
    // `setMergeSeparator`, gemessen in tests/unit/ClQuestionRowKey.spec.ts.
    setCalcRowKey(value) {
      this.$set(this.entry, "calcRowKey", value === true);
    },
    // `$set` statt `v-model`: an einem Pruefpunkt, der vor der
    // Schema-Erweiterung gespeichert wurde, fehlt der Schluessel. Eine
    // gewoehnliche Zuweisung legt ihn an, ohne dass Vue 2 eine Abhaengigkeit
    // darauf kennt - `hasChanges` (die Farbe des Speichern-Knopfes) wertet den
    // Spread `{ ...this.entry }` dann nicht neu aus, der Knopf bliebe grau,
    // obwohl etwas getippt wurde. Gleiches Muster wie `setCalcRowKey` und
    // `setMergeSeparator`, gemessen in tests/unit/ClQuestionReportAffix.spec.ts.
    setReportPrefix(value) {
      this.$set(this.entry, "reportPrefix", value === null || value === undefined ? "" : String(value));
    },
    setReportSuffix(value) {
      this.$set(this.entry, "reportSuffix", value === null || value === undefined ? "" : String(value));
    },
    _validateFormulaField(formula) {
      const result = validateFormulaSyntax(formula);
      if (!result.ok) return [result.error];
      const siblings = this.$store.state.cl_question_list || [];
      const unknown = findUnknownVars(formula, siblings, this.entry._id);
      if (unknown.length > 0) {
        return [this.$t("CALC_FORMULA_REF_UNKNOWN").replace("{var}", unknown.join(", "))];
      }
      return [];
    },
    addCalcMapping() {
      if (!this.entry.calcMapping) this.$set(this.entry, "calcMapping", []);
      this.entry.calcMapping.push({ key: "", value: 0 });
    },
    removeCalcMapping(idx) {
      this.entry.calcMapping.splice(idx, 1);
    },
    updateInformElement: function (d) {
      if (d.type != "question" && d.uid != this.entry.uid) {
        console.log("QUESTION speichern");
        this.save();
      }
    },
    rowclick(item) {
      this.$emit("selectAnswer", item);
    },
    createAct: function (type) {
      this.$emit("createAct", { type: type });
    },
    sortAct: function (type) {
      this.$emit("sortAct", { type: type });
    },
    deleteAct: function (type) {
      this.entry.type = type;
      this.$emit("deleteAct", this.entry);
    },
    copyAct: function (type) {
      this.entry.type = type;
      this.$emit("copyAct", {
        type: type,
        cl_uid: this.entry.cl_uid,
        uid: this.entry.uid,
        name: this.entry.name,
      });
    },
    duplicateQuestionAct: function () {
      this.$emit("duplicateQuestionAct", this.entry);
    },
    close: function () {
      EventBus.$emit("question_closed", this.entry);
    },
    pasteEntry: function () {
      this.$emit("pasteAct");
    },
    pasteOptionEntry: function (item) {
      item.paste_cl_uid = this.entry.cl_uid;
      item.paste_question_uid = this.entry.uid;

      this.$emit("duplicateAct", { type: "answer", item: item });

      console.log("pasteOptionEntry", item);
      // paste_cl_uid
      // paste_question_uid

      /*
      getAnswer(item.cl_uid, item.uid)
        .then(resp => { 
          console.log("resp", resp)
        })
      */
    },
    onSortEnd: function () {
      sortItems(this.answers, {
        type: "answer",
        cl_uid: this.$store.state.cl_uid,
      })
        .then((resp) => {
          if (resp.status == "success") {
          }
        })
        .catch((e) => {
          console.log("error", e);
        });
    },
    copyEntry: function (e, item, duplicate) {
      e.stopPropagation();
      if (duplicate) {
        item.cl_uid = this.$store.state.cl_uid;
        this.$emit("duplicateAct", { type: "answer", item: item });
      } else {
        console.log(item);
        this.$store.state.pasteEntryOptionVal = {
          text: item.text,
          value: item.value,
          cl_uid: this.$store.state.cl_uid,
        };
        this.bc.postMessage({
          type: "COPY_OPTION",
          pasteItem: this.pasteEntryVal,
        });
      }
    },
    updateUsername: function () {
      if (this.entry.user_uid) {
        this.username = this.$store.state.users[this.entry.user_uid];
      } else {
        this.username = "";
      }
    },
    save() {
      //this.loading = true;

      let check1 = { ...this.org_entry };
      let check2 = { ...this.entry };
      delete check1.created_at;
      delete check2.created_at;
      delete check1.user_uid;
      delete check2.user_uid;
      delete check1.type;
      delete check2.type;

      this.entry.type = "question";

      if (
        JSON.stringify(check1) != JSON.stringify(check2) ||
        this.entry.machines.length != this.org_machines.length
      ) {
        this.entry.user_uid = this.$store.state.userId;
        this.entry.created_at = Date.now();
        this.updateUsername();
        this.org_entry = { ...this.entry };
        this.$emit("updateAct", this.entry);
        EventBus.$emit("updateInformElement", {
          type: "question",
          uid: this.entry.uid,
        });
      } else {
        this.$emit("updateAct", { no_changes: true });
      }
    },
    questionChangedHandler: function (data) {
      this.org_entry = { ...this.entry };
      this.org_machines = JSON.parse(JSON.stringify(this.entry.machines));
      this.updateUsername();
    },
    dialogClosed: function (val) {
      this.showMachines = false;
    },
    changeMachines: function (val) {
      this.showMachines = false;
      // {add_machines: this.add_machines, remove_machines: this.remove_machines}
      this.entry.machines = val.add_machines;
      this.entry.remove_machines = val.remove_machines;

      if (val.group_uid) {
        // Es wurde eine neue Gruppe aus der Auswahl erstellt
        this.entry.machinegroup_list = [val.group_uid];
      }
    },
    openMachinesDialog: function () {
      this.sel_addmachines = JSON.parse(JSON.stringify(this.entry.machines));
      this.sel_removemachines = JSON.parse(
        JSON.stringify(this.entry.remove_machines)
      );
      this.showMachines = true;

      this.sel_machinesingroup = [];

      if (this.machinegroups) {
        for (let k of this.machinegroups) {
          if (this.entry.machinegroup_list) {
            for (let m of this.entry.machinegroup_list) {
              if (k.value == m) {
                this.sel_machinesingroup = this.sel_machinesingroup.concat(
                  JSON.parse(JSON.stringify(k.machines))
                );
              }
            }
          } else {
            if (k.value == this.entry.machinegroup) {
              this.sel_machinesingroup = JSON.parse(JSON.stringify(k.machines));
              break;
            }
          }
        }
      }
    },

  },
};
